import { defineMessages } from 'react-intl';

export default defineMessages({
    buildingTitle: {
        id: 'wmic.pe-capability-quoteandbind-common-react.pages.building-coverages-table-component.buildingTitle',
        defaultMessage: 'Building #{displayName}',
    },
});
